export default {
  SELECT_TIMELINE: 'SELECT_TIMELINE',
  UPDATE_TIMELINE_SELECTION: 'UPDATE_TIMELINE_SELECTION',
  UPDATE_ALL_TIMELINE_BRICK: 'UPDATE_ALL_TIMELINE_BRICK',
  UPDATE_ALL_TIMELINE_GRAPH: 'UPDATE_ALL_TIMELINE_GRAPH',
  CHANGE_EXPORT_PANEL_SHOW_STATE: 'CHANGE_EXPORT_PANEL_SHOW_STATE',
  CHANGE_EXPORT_PROCESS_STEP: 'CHANGE_EXPORT_PROCESS_STEP',
  CHANGE_EXPORT_RESOLUTION: 'CHANGE_EXPORT_RESOLUTION',
  EXPORTING: 'EXPORTING',
  SIZE_CHOOSE: 'SIZE_CHOOSE',
  EXPORTING_SUCCESS: 'EXPORTING_SUCCESS',
  DRAG_FILE_MODE_RESOURCE: 'DRAG_FILE_MODE_RESOURCE',
  TOGGLE_DRAG_FILE_MODE: 'TOGGLE_DRAG_FILE_MODE',
  SHOW_CONFIRM_MODAL: 'SHOW_CONFIRM_MODAL',
  HIDE_CONFIRM_MODAL: 'HIDE_CONFIRM_MODAL',
  SET_MEDIA_LIST: 'SET_MEDIA_LIST',
  SET_CHOOSE_MEDIA_LIST: 'SET_CHOOSE_MEDIA_LIST',
  CHANGE_VIDEO_PLAYING_STATUS: 'CHANGE_VIDEO_PLAYING_STATUS',
  SET_VIDEO_PREVIEW_PROGRESS: 'SET_VIDEO_PREVIEW_PROGRESS',
  SET_HOVER_MEDIA_ID: 'SET_HOVER_MEDIA_ID',
  SET_INITIAL_LINE_POSITION: 'SET_INITIAL_LINE_POSITION',
  SET_PREVIEW_LINE_POSITION: 'SET_PREVIEW_LINE_POSITION',
  SET_CLICK_MEDIA_ID: 'SET_CLICK_MEDIA_ID',
  UPDATE_DURATION: 'UPDATE_DURATION',
  SET_DRAGGING_STATE:'SET_DRAGGING_STATE',
  SET_EXPORT_PROGRESS: 'SET_EXPORT_PROGRESS',
  SET_YOUTUBE_SHARING: 'SET_YOUTUBE_SHARING',
  SET_YOUTUBE_PROGRESS: 'SET_YOUTUBE_PROGRESS',
  SET_VIDEO_CURRENT_TIME: 'SET_VIDEO_CURRENT_TIME',
  EVENT_TIMELINE_LAYOUT: 'EVENT_TIMELINE_LAYOUT',
  SET_VIDEO_PREVIEW_TIME: 'SET_VIDEO_PREVIEW_TIME',
  EVENT_UNIT_CONVERSION_CHANGE: 'EVENT_UNIT_CONVERSION_CHANGE',
  UPDATE_REAL_DURATION: 'UPDATE_REAL_DURATION',
  CHANGE_SCREEN_RECORDING_TYPE: 'CHANGE_SCREEN_RECORDING_TYPE',
  SET_SCREEN_RECORDING_STATE: 'SET_SCREEN_RECORDING_STATE',
  UPDATE_VIDEO_SOURCE: 'UPDATE_VIDEO_SOURCE',
  SET_IS_SHOW_SCREEN_RECORDING_MODAL: 'SET_IS_SHOW_SCREEN_RECORDING_MODAL',
  SET_IS_SHOW_LOADING_MODAL: 'SET_IS_SHOW_LOADING_MODAL',
  SET_IS_SHOW_RECORDING_MODAL: 'SET_IS_SHOW_RECORDING_MODAL',
  SET_CAMERA_LIST: 'SET_CAMERA_LIST',
  SET_MICROPHONE_LIST: 'SET_MICROPHONE_LIST',
  SET_VIDEO_TAPE_SRC: 'SET_VIDEO_TAPE_SRC',
  CHANGE_RECORDING_CONFIG: 'CHANGE_RECORDING_CONFIG',
  SET_CURRENT_STAGE: 'SET_CURRENT_STAGE',
  SET_TIME_LINE_HEIGHT_RADIO: 'SET_TIME_LINE_HEIGHT_RADIO',
  SET_IS_SHOW_TEXT_EDITOR_MODAL: 'SET_IS_SHOW_TEXT_EDITOR_MODAL',
  SET_TIMELINE_ADSORPTION: 'SET_TIMELINE_ADSORPTION',
  UPDATE_TEXT_ANIMATION_TOOLBAR: 'UPDATE_TEXT_ANIMATION_TOOLBAR',
  SET_TEXT_ANIMATION_CONTENT: 'SET_TEXT_ANIMATION_CONTENT',
  SET_TEXT_ANIMATION_FOCUS_INDEX: 'SET_TEXT_ANIMATION_FOCUS_INDEX',
  SET_TEXT_ANIMATION_ALIGNMENT: 'SET_TEXT_ANIMATION_ALIGNMENT',
  SET_TEXT_ANIMATION_COLOR_LENGTH: 'SET_TEXT_ANIMATION_COLOR_LENGTH',
  SET_TEXT_ANIMATION_TEXT_LENGTH: 'SET_TEXT_ANIMATION_TEXT_LENGTH',
  SET_TEXT_ANIMATION_BOLD: 'SET_TEXT_ANIMATION_BOLD',
  SET_TEXT_ANIMATION_ITALIC: 'SET_TEXT_ANIMATION_ITALIC',
  SET_TEXT_ANIMATION_COLOR: 'SET_TEXT_ANIMATION_COLOR',
  SET_OVERLAY_COLORS: 'SET_OVERLAY_COLORS',
  SET_OVERLAY_POSITION: 'SET_OVERLAY_POSITION',
  SET_OVERLAY_TEXT_BOLD: 'SET_OVERLAY_TEXT_BOLD',
  SET_OVERLAY_TEXT_ITALIC: 'SET_OVERLAY_TEXT_ITALIC',
  SET_WIDGET_COLOR: 'SET_WIDGET_COLOR',
  SET_SVG_COLOR: 'SET_SVG_COLOR',
  UPDATE_FONTFAMILY: 'UPDATE_FONTFAMILY',
  TOOLBAR_VOLUME_CHANGED: 'TOOLBAR_VOLUME_CHANGED',
  TOOLBAR_TYPE_CHANGED: 'TOOLBAR_TYPE_CHANGED',
  TOOLBAR_ZOOM_SCALE_CHANGED: 'TOOLBAR_ZOOM_SCALE_CHANGED',
  DOCUMENT_COLOR_CHANGED: 'DOCUMENT_COLOR_CHANGED',
  SET_LOADING_FONT: 'SET_LOADING_FONT',
  SET_VIDEO_VOLUME: 'SET_VIDEO_VOLUME',
  SET_VIDEO_SPEED: 'SET_VIDEO_SPEED',
  SET_VIDEO_ZOOM_SCALE: 'SET_VIDEO_ZOOM_SCALE',
  SET_AUDIO_VOLUME: 'SET_AUDIO_VOLUME',
  SET_PHOTO_ZOOM_SCALE: 'SET_PHOTO_ZOOM_SCALE',
  SET_PHOTO_MEDIA_STATUS: 'SET_PHOTO_MEDIA_STATUS',
  SET_AUDIO_MEDIA_STATUS: 'SET_AUDIO_MEDIA_STATUS',
  SET_VIDEO_MEDIA_STATUS: 'SET_VIDEO_MEDIA_STATUS',
  SET_OVERLAY_MEDIA_STATUS: 'SET_OVERLAY_MEDIA_STATUS',
  SET_EDIT_MODE: 'SET_EDIT_MODE',
  SET_IS_SHOW_RELINK_MODAL: 'SET_IS_SHOW_RELINK_MODAL',
  UPDATE_LINK_MEDIA_LIST: 'UPDATE_LINK_MEDIA_LIST',
  SET_SHOW_POPOVER_TYPE: 'SET_SHOW_POPOVER_TYPE',
  SET_ANONYMOUS_SAVE_STATUS: 'SET_ANONYMOUS_SAVE_STATUS',
  UPDATE_LOGIN_STATUS: 'UPDATE_LOGIN_STATUS',
  SET_IS_SHOW_RECORD_FROM_MODAL: 'SET_IS_SHOW_RECORD_FROM_MODAL',
  UPDATE_PROJECT_NAME: 'UPDATE_PROJECT_NAME',
  UPDATE_EDITOR_NAME: 'UPDATE_EDITOR_NAME',
  UPDATE_UNDO_REDO: 'UPDATE_UNDO_REDO',
  INIT_CONFIRM_MODAL_DATA: 'INIT_CONFIRM_MODAL_DATA',
  SET_BACKGROUND_COLOR_BACKGROUND_COLOR: 'SET_BACKGROUND_COLOR_BACKGROUND_COLOR',
  UPDATE_COPY_STATUS: 'UPDATE_COPY_STATUS',
  UPDATE_PASTE_STATUS: 'UPDATE_PASTE_STATUS',
  SET_MAIN_LAYER_VOLUME: 'SET_MAIN_LAYER_VOLUME',
  UPDATE_SPLIT_STATUS: 'UPDATE_SPLIT_STATUS',
  SET_CROP_MODE: 'SET_CROP_MODE',
  SET_MASK_TYPE: 'SET_MASK_TYPE',
  SET_MASK_ENABLE: 'SET_MASK_ENABLE',
  UPDATE_UNIT_CONVERSION: 'UPDATE_UNIT_CONVERSION',
  // =========Element
  UPDATE_SHOW_TYPE: 'UPDATE_SHOW_TYPE',
  UPDATE_LAST_TYPE: 'UPDATE_LAST_TYPE',
  TOGGLE_RESOURCE_EXPAND: 'TOGGLE_RESOURCE_EXPAND',
  UPDATE_FILTRATE_MEDIA_TYPE: 'UPDATE_FILTRATE_MEDIA_TYPE',
  UPDATE_COVER_ELE_STATUS: 'UPDATE_COVER_ELE_STATUS',
  SET_SHOW_EDIT_MODE: "SET_SHOW_EDIT_MODE",
  SET_ANIMATION_INTRO_SLOT: 'SET_ANIMATION_INTRO_SLOT',
  SET_ANIMATION_OUTRO_SLOT: 'SET_ANIMATION_OUTRO_SLOT',
  CUT_LINK_BTN: 'CUT_LINK_BTN',
  CUT_SCROLL_TYPE: 'CUT_SCROLL_TYPE',
  HIDE_DRAG_FILE_MODE: 'HIDE_DRAG_FILE_MODE',
  SET_IS_SHOW_QUICK_GUIDE_MODAL: 'SET_IS_SHOW_QUICK_GUIDE_MODAL',
  MENU_TYPE_CHANGE: 'MENU_TYPE_CHANGE',
	// =======transform
	ROTATE_LEFT: 'ROTATE_LEFT',
	ROTATE_RIGHT: 'ROTATE_RIGHT',
	FLIP_HORIZONTALLY: 'FLIP_HORIZONTALLY',
	FLIP_VERTICALLY: 'FLIP_VERTICALLY',
	SET_PHOTO_ANIMATION_SLOT: 'SET_PHOTO_ANIMATION_SLOT',
	SET_MEDIA_OPACITY_VALUE: 'SET_MEDIA_OPACITY_VALUE',

  SET_WATERMARK_TYPE: 'SET_WATERMARK_TYPE',
	SET_WATERMARK_TEXT_VALUE: 'SET_WATERMARK_TEXT_VALUE',
	SET_WATERMARK_TEXT_COLOR: 'SET_WATERMARK_TEXT_COLOR',
	SET_WATERMARK_FONT_FAMILY: 'SET_WATERMARK_FONT_FAMILY',
	UP_WATERMARK_SIZE: 'UP_WATERMARK_SIZE',
	UP_WATERMARK_OPACITY: 'UP_WATERMARK_OPACITY',
	UP_WATERMARK_POSITION: 'UP_WATERMARK_POSITION',
	SET_WATERMARK_SIZE: 'SET_WATERMARK_SIZE',
	SET_WATERMARK_OPACITY: 'SET_WATERMARK_OPACITY',
	SET_WATERMARK_POSITION: 'SET_WATERMARK_POSITION',
	SET_WATERMARK_URL: 'SET_WATERMARK_URL',
	SET_WATERMARK_STATUS: 'SET_WATERMARK_STATUS',
	SET_WATERMARK_PROGRESS: 'SET_WATERMARK_PROGRESS',
	SET_IS_SHOW_STOCK_VIDEO_MODAL: 'SET_IS_SHOW_STOCK_VIDEO_MODAL',
	SET_WATERMARK_IMAGE_IS_EXIST: 'SET_WATERMARK_IMAGE_IS_EXIST',
	CUT_STOCK_VIDEO_OPTION: 'CUT_STOCK_VIDEO_OPTION',
	SHOW_STOCK_DETAILS_MODAL: 'SHOW_STOCK_DETAILS_MODAL',
	HIDE_STOCK_DETAILS_MODAL: 'HIDE_STOCK_DETAILS_MODAL',
	SET_SEARCH_VIDEO_VALUE: 'SET_SEARCH_VIDEO_VALUE',
  SET_SEARCH_VIDEO_LOADING: 'SET_SEARCH_VIDEO_LOADING',
  SET_SEARCH_VIDEO_SUBLOADING: 'SET_SEARCH_VIDEO_SUBLOADING',
  SET_SEARCH_VIDEO_SORT: 'SET_SEARCH_VIDEO_SORT',
  SET_STOCK_VIDEO_STATUS: 'SET_STOCK_VIDEO_STATUS',
  SET_STOCK_IMAGE_STATUS: 'SET_STOCK_IMAGE_STATUS',
  SET_STOCK_AUDIO_STATUS: 'SET_STOCK_AUDIO_STATUS',
	SET_SEARCH_VIDEOS: 'SET_SEARCH_VIDEOS',
	SET_SEARCH_AUDIOS: 'SET_SEARCH_AUDIOS',
	SET_SEARCH_IMAGES: 'SET_SEARCH_IMAGES',

	SET_VIDEO_MEDIA_NAME: 'SET_VIDEO_MEDIA_NAME',
	SET_IMAGE_MEDIA_NAME: 'SET_IMAGE_MEDIA_NAME',
	SET_AUDIO_MEDIA_NAME: 'SET_AUDIO_MEDIA_NAME',

  UPDATE_INTRO: 'UPDATE_INTRO',
  UPDATE_INTRO_STATUS: 'UPDATE_INTRO_STATUS',
  UPDATE_EXPORT_VIDEO_NAME: 'UPDATE_EXPORT_VIDEO_NAME',
  UPDATE_USER_CHANGED_INTRO: 'UPDATE_USER_CHANGED_INTRO',
  INIT_INTROS: 'INIT_INTROS',

  UPDATE_USER_LIMIT_STATUS: 'UPDATE_USER_LIMIT_STATUS',
  UPDATE_USER_PAYMENT_LEVEL: 'UPDATE_USER_PAYMENT_LEVEL',

  UPDATE_EXPORT_PREVIEW_PLAYING: 'UPDATE_EXPORT_PREVIEW_PLAYING',
  UPDATE_EXPORT_PREVIEW_CURRENT_TIME: 'UPDATE_EXPORT_PREVIEW_CURRENT_TIME',
  SET_EXPORT_PREVIEW_DURATION: 'SET_EXPORT_PREVIEW_DURATION',
  UPDATE_EXPORT_PREVIEW_VOLUME: 'UPDATE_EXPORT_PREVIEW_VOLUME',

  SET_IS_SHOW_DROPBOX_MODAL: "SET_IS_SHOW_DROPBOX_MODAL",
  SET_IS_SHOW_DROPBOX_SUCCESS_MODAL: "SET_IS_SHOW_DROPBOX_SUCCESS_MODAL",

  SET_RATIO_TYPE: "SET_RATIO_TYPE",
  SET_PREVIEW_RATIO_TYPE: "SET_PREVIEW_RATIO_TYPE",

  SET_AUDIO_FADE_IN: "SET_AUDIO_FADE_IN",
  SET_AUDIO_FADE_OUT: "SET_AUDIO_FADE_OUT",

  // 云存储
  CLOUD_STATUS_CHANGED: "CLOUD_STATUS_CHANGED",
  CLOUD_STATUS_SYNC: "CLOUD_STATUS_SYNC",
  CLOUD_STATUS_IDLE: "CLOUD_STATUS_IDLE",
  CLOUD_STATUS_FULL: "CLOUD_STATUS_FULL",
  CLOUD_STATUS_FAIL: "CLOUD_STATUS_FAIL",
  SET_IS_SHOW_CLOUD_BENEFIT_MODAL: "SET_IS_SHOW_CLOUD_BENEFIT_MODAL",
  CLOUD_STATUS_UPDATE_ALL: "CLOUD_STATUS_UPDATE_ALL",
  CLOUD_SYNC_START: "CLOUD_SYNC_START",
  CLOUD_SPACE_CHANGED: "CLOUD_SPACE_CHANGED",
  ADD_CLOUD_FULL_MEDIA:"ADD_CLOUD_FULL_MEDIA",
  CLEAR_CLOUD_FULL_MEDIA: "CLEAR_CLOUD_FULL_MEDIA"
}
